<div class="row">
  <div class="col-12 col-md-4">
    <div class="cx-product-manufacturer" aria-label="Product manufacturer">
      {{ product.manufacturer }}
    </div>
    <a [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" class="cx-product-image-container" tabindex="-1">
      <cx-media class="cx-product-image" [container]="product.images?.PRIMARY" format="product" [alt]="product.summary">
      </cx-media>
    </a>
    @if (!hasShopViewUserRole) {
      <div class="cx-product-campaign">
        <app-uig-marketplace-icon [marketplace]="product.marketplace" [vendor]="product.vendor"></app-uig-marketplace-icon>
        @for (campaign of product.campaignsTypes; track campaign) {
          <img src="{{ resolveAbsoluteUrl(campaign.url) }}"
            title="{{ campaign.name }}" />
        }
        @if (product.mvgr2 && product.mvgr2.icon && (product.mvgr2.icon.altText || product.mvgr2.name)) {
          <img
            src="{{ resolveAbsoluteUrl(product.mvgr2.icon.url) }}" title="{{ product.mvgr2.name }}"
            alt="{{ product.mvgr2.icon.altText }}" />
        }
        @if (product.mvgr3 && product.mvgr3.icon && (product.mvgr3.icon.altText || product.mvgr3.name)) {
          <img
            src="{{ resolveAbsoluteUrl(product.mvgr3.icon.url) }}" title="{{ product.mvgr3.name }}"
            alt="{{ product.mvgr3.icon.altText }}" />
        }
      </div>
    }
  </div>
  <div class="col-12 col-md-8">
    <a [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" class="cx-product-name"
    [innerHtml]="product.nameHtml"></a>

    <div class="cx-product-code" aria-label="Product code">
      {{ "product.code" | cxTranslate }} {{ product.code }}
    </div>

    @if (product.variantOptions) {
      <cx-variant-style-icons [variants]="product.variantOptions"></cx-variant-style-icons>
    }

    <div class="row">
      <div class="col-12 col-md-8">
        <p class="cx-product-summary" [innerHtml]="product.summary">
          {{ product.summary }}
        </p>
        @if (product.marketingText1 && !hasShopViewUserRole) {
          <div class="cx-product-marketingtext1" [innerHTML]="product.marketingText1 | safeHtml"></div>
        }
        @if (!hasShopViewUserRole) {
          <app-uig-campaign-note [product]="product"></app-uig-campaign-note>
        }
        @if (!hasShopViewUserRole) {
          <div class="prod-list-item__ek-price-container" aria-label="Product ek price">
            <span class="prod-list-item__ek-price">{{ product.ekPrice?.formattedValue }} </span>
            @if (product.ekPriceChange) {
              <img src="assets/images/pricechange/{{product.ekPriceChange}}.png"
                class="prod-list-item__price-badge"
                title="{{ 'product.priceChange.' + product.ekPriceChange | cxTranslate : { date: product.formattedEkPriceChangeDate } }}" />
            }
          </div>
        }
      </div>
      <div class="col-12 col-md-4">
        <ng-template [cxOutlet]="ProductListOutlets.ITEM_ACTIONS">
          @if (product.stock?.stockLevelStatus !== 'outOfStock' && !hasShopViewUserRole) {
            <app-uig-add-to-cart
              [showQuantity]="false"
              [product]="product">
            </app-uig-add-to-cart>
          }
        </ng-template>
        <app-uig-availability [product]="product"></app-uig-availability>
      </div>
    </div>
    @if (product.ean) {
      <div class="cx-product-ean" aria-label="Product ean">
        {{ "product.ean" | cxTranslate }} {{ product.ean }}
      </div>
    }
    @if (product.rfuvpPrice) {
      <div class="cx-product-uvp-price" aria-label="Product RF UVP price">
        {{ "product.rfuvpPrice" | cxTranslate }}
        {{ product.rfuvpPrice?.formattedValue }}
      </div>
    }
    @if (product.uvpPrice) {
      <div class="cx-product-uvp-price" aria-label="Product uvp price">
        {{ "product.uvpPrice" | cxTranslate }}
        {{ product.uvpPrice?.formattedValue }}
      </div>
    }
    @if (!hasShopViewUserRole) {
      <app-uig-add-to-wishlist checkboxStyle="true" [product]="product"></app-uig-add-to-wishlist>
    }
  </div>
</div>
